export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["READY"] = "READY";
    FileUploadStatus["IN_PROGRESS"] = "IN_PROGRESS";
    FileUploadStatus["FAILED"] = "FAILED";
    FileUploadStatus["SUCCESS"] = "SUCCESS";
    FileUploadStatus["CANCELLED"] = "CANCELLED";
})(FileUploadStatus || (FileUploadStatus = {}));
//# sourceMappingURL=FileUploadStatus.js.map